module.exports = __webpack_public_path__ + "img/ukraina.d58650fd.svg";